import { ROOT_TOKENS_COLORS } from '@constants/colors.ts';
import { Layout as BaseLayout } from 'antd';
import styled from 'styled-components';

export const Header = styled(BaseLayout.Header)`
    background: ${ROOT_TOKENS_COLORS.white.default};
`;
